import { render, staticRenderFns } from "./TableLayout.vue?vue&type=template&id=4fdfe3cf&scoped=true"
import script from "./TableLayout.vue?vue&type=script&lang=js"
export * from "./TableLayout.vue?vue&type=script&lang=js"
import style0 from "./TableLayout.vue?vue&type=style&index=0&id=4fdfe3cf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_css-loader@6.11.0_webpack@5.94.0__handlebars@4.7._pgqouf3rnsspsizlpwr4yhs5p4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdfe3cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fdfe3cf')) {
      api.createRecord('4fdfe3cf', component.options)
    } else {
      api.reload('4fdfe3cf', component.options)
    }
    module.hot.accept("./TableLayout.vue?vue&type=template&id=4fdfe3cf&scoped=true", function () {
      api.rerender('4fdfe3cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/ui/components/tableLayout/TableLayout.vue"
export default component.exports